<template>
  <div>
    <template v-if="!isPublic">
      <v-app>
        <app-core-admin-app-bar
          :style="drawerVisible ? 'margin-left: 80px' : ''"
          v-if="isAdmin"
        />
        <app-core-app-bar
          :style="drawerVisible ? 'margin-left: 80px' : ''"
          v-if="!isAdmin && isLoggedIn"
        />
        <app-core-drawer v-if="isLoggedIn" />
        <v-content :style="drawerVisible ? 'margin-left: 80px' : ''">
          <router-view />
        </v-content>
        <app-core-footer :style="drawerVisible ? 'margin-left: 80px' : ''" />
        <v-hover v-slot="{ hover }">
          <v-snackbar
            :elevation="hover ? 16 : 2"
            :timeout="hover ? -1 : snackbar.timeout"
            top
            center
            :color="snackbar.color"
            v-model="snackbar.show"
          >
            <div style="line-break: anywhere;" v-html="snackbarText"></div>
            <template v-slot:action="{ attrs }">
              <v-btn
                dark
                v-bind="attrs"
                @click.native="snackbar.show = false"
                icon
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
        </v-hover>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import AppEvents from "./event";
import axios from "axios";

export default {
  name: "App",
  components: {
    AppCoreAppBar: () => import("./components/core/AppBar"),
    AppCoreAdminAppBar: () => import("./components/core/AdminAppBar"),
    AppCoreDrawer: () => import("./components/core/Drawer"),
    AppCoreFooter: () => import("./components/core/Footer"),
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "",
      timeout: 3000,
    },
  }),

  computed: {
    isPublic() {
      if (this.$route && this.$route.meta) return this.$route.meta.public;
      return true;
    },
    snackbarText() {
      return this.snackbar.text.replaceAll("\n", "<br/>").replaceAll("\r\n", "<br/>");
    },
    isAdmin() {
      return (
        this.$store.getters["account/user"] &&
        this.$store.getters["account/user"].IsAdmin
      );
    },
    isLoggedIn() {
      return this.$store.getters["account/isLoggedIn"];
    },
    drawerVisible() {
      return !this.$vuetify.breakpoint.mobile;
    },
  },
  created() {
    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;

    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function () {
        if (err.response) {
          if (
            (err.response.status === 401 || err.response.status === 403) &&
            err.config &&
            !err.config.__isRetryRequest &&
            !window.location.hash.substring(2).startsWith("external")
          ) {
            var redirectUrl = window.location.hash.substring(1);
            window.getApp.$emit(
              "APP_LOGOUT",
              redirectUrl.includes("login") ? "" : redirectUrl
            );
          }

          if (err.response.status === 400 && err.response.data) {
            window.getApp.$emit("APP_BAD_REQUEST", err.response.data);
          }
        } else {
          window.getApp.$emit("APP_BAD_REQUEST", err.message);
        }
        throw err;
      });
    });

    axios.get("/config.json").then((resp) => {
      this.$store.dispatch("account/setApiUrl", resp.data.apiUrl);
      this.$store.dispatch(
        "account/setDefaultLanguage",
        resp.data.defaultLanguage
      );
      this.$store.dispatch(
        "account/setLoginParams",
        resp.data.siteConfig.loginParams
      );

      this.$store.dispatch("theme/load", resp.data.siteConfig);
      this.$vuetify.theme.dark = resp.data.siteConfig.dark;
      this.$vuetify.theme.themes[
        resp.data.siteConfig.dark ? "dark" : "light"
      ].primary = resp.data.siteConfig.color;
    });
  },
};
</script>
